import React, { useState, useEffect } from "react";
import "./dpp-report.css";
import FormInputs from "./FormInputs";
import DropDown from "./Dropdown";
import WarningImg from "./../../../Assets/Images/CommanImages/Warning.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import TableComponent from "./TableComponent";
import axios from "axios";

function AttendanceReport({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setLoaderOrNot,
}) {
  const [value, setValues] = useState({
    by_batch: "",
    by_course: "",
    by_student: "",
    last_month: "",
    month_to_date: "",
    week_to_date: "",
    custom: "",
    recurrence: "By Batch",
    start_month: "",
    end_month: "",
  });
  const [disabled, setDisabled] = useState(false);
  const [batches, setBatches] = useState([]);
  const [courses, setCourses] = useState([]);
  const [students, setStudents] = useState([]);

  const onChange = async (e) => {
    const { name, value: inputValue, type } = e.target;
    if (type === "radio" && name === "recurrence") {
      setValues((prevState) => ({
        ...prevState,
        recurrence: inputValue,
      }));

      // Fetch the data based on the selected radio button
      if (inputValue === "By Batch") {
        await fetchBatches();
      } else if (inputValue === "By Course") {
        await fetchCourses();
      } else if (inputValue === "By Student") {
        await fetchStudents();
      }
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: inputValue,
      }));
    }
  };

  useEffect(() => {
    if (value.recurrence === "By Batch") {
      fetchBatches();
    }
  }, []); // Fetch batches when component mounts

  const fetchBatches = async () => {
    try {
      const response = await axios.get(
        "https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/get-batches/"
      );
      if (response.data.status === "success") {
        setBatches(response.data.data);
      } else {
        console.error("Failed to fetch batches");
      }
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };

  const fetchCourses = async () => {
    try {
      const response = await axios.get(
        "https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/get-courses/"
      );
      setCourses(response.data);
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };

  const fetchStudents = async () => {
    // Implement your logic to fetch students
    // setStudents(fetchedStudents);
  };

  const handleApplyClick = () => {
    setDisabled(!disabled);
  };

  const headers = [
    "Student Name",
    "Roll No",
    "Batch",
    "Course",
    "ID",
    "Agents",
    "Map",
    "Skins",
    "Status",
  ];
  const data = [
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "AAAAAAJohn Doe",
      "201",
      "2022",
      "Physics",
      "123",
      "Joru",
      "Online",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "John Doe",
      "001",
      "2024",
      "Physics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Jane Smith",
      "002",
      "2023",
      "Chemistry",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Michael Brown",
      "003",
      "2024",
      "Mathematics",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
    [
      "Emily Davis",
      "004",
      "2023",
      "Biology",
      "123",
      "Yoru",
      "Abyss",
      "Vandel",
      "Online",
    ],
  ];

  return (
    <div className="create-role-container-dpp" style={{ color: "#424242" }}>
      <div className="overlay-container">
        {disabled && (
          <div className="overlay">
            {/* Optionally add text or loading spinner here */}
          </div>
        )}
        <div className="create-role-container-dpp">
          <div
            className="create-role-container-header"
            style={{ zIndex: "1000" }}
          >
            <span className="create-role-heading" style={{ color: "#424242" }}>
              DPP ATTENDENCE
            </span>
            <div className="cr-header-btn-container">
              <button className="cr-cancel-btn-dpp-report">CANCEL</button>
              {disabled ? (
                <button
                  className="cr-create-btn-dpp-report"
                  onClick={handleApplyClick}
                >
                  <p
                    style={{ fontWeight: "700" }}
                    onClick={() => {
                      setActiveImg(ErrorImg);
                      setIsMessageBoxVisible(true);
                      setMessageBox("Reset All");
                      setTimeout(function () {
                        setIsMessageBoxVisible(false);
                      }, 3000);
                      // setLoaderOrNot(false);
                    }}
                  >
                    RESET
                  </p>
                </button>
              ) : (
                <button
                  className="cr-create-btn-dpp-report"
                  onClick={handleApplyClick}
                >
                  <p
                    style={{ fontWeight: "700" }}
                    onClick={() => {
                      setIsMessageBoxVisible(true);
                      setMessageBox("Loading...");
                      setTimeout(function () {
                        setIsMessageBoxVisible(false);
                      }, 2000);
                      setActiveImg(WarningImg);
                      // setLoaderOrNot(true);
                    }}
                  >
                    APPLY
                  </p>
                </button>
              )}
            </div>
          </div>
          <p>
            View, create, or filter reports. View and manage the list of reports
            already available or create a new report.
          </p>
          <div style={{ marginTop: "20px" }}>
            <div className="grid-container-radio-button">
              <div className="item1">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="by batch"
                    name="recurrence"
                    value="By Batch"
                    checked={value.recurrence === "By Batch"}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <label htmlFor="by batch">By Batch</label>
                </div>
              </div>
              <div className="item2">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="by course"
                    name="recurrence"
                    value="By Course"
                    checked={value.recurrence === "By Course"}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <label htmlFor="by course">By Course</label>
                </div>
              </div>
              <div className="item3">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="by student"
                    name="recurrence"
                    value="By Student"
                    checked={value.recurrence === "By Student"}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <label htmlFor="by student">By Student</label>
                </div>
              </div>
              <div className="item4">
                {value.recurrence === "By Batch" && (
                  <DropDown
                    setSelected={(batchName) =>
                      setValues((prevState) => ({
                        ...prevState,
                        by_batch: batchName,
                      }))
                    }
                    options={batches.map((batch) => ({
                      label: batch.batch_name,
                      id: batch.batch_id,
                    }))}
                    placeholder="Select Batch" // Add placeholder prop
                    disabled={disabled}
                  />
                )}
                {value.recurrence === "By Course" && (
                  <DropDown
                    setSelected={(course) =>
                      setValues((prevState) => ({
                        ...prevState,
                        by_course: course,
                      }))
                    }
                    options={courses.map((course) => ({
                      label: course.course_name,
                      id: course.course_id,
                    }))}
                    placeholder="Select Course"
                    disabled={disabled}
                  />
                )}
                {value.recurrence === "By Student" && (
                  <DropDown
                    setSelected={(student) =>
                      setValues((prevState) => ({
                        ...prevState,
                        by_student: student,
                      }))
                    }
                    options={students.map((student) => ({
                      label: student.student_name,
                      id: student.student_id,
                    }))}
                    placeholder="Select Student"
                    disabled={disabled}
                  />
                )}
              </div>
            </div>
            <div className="grid-container-radio-button">
              <div className="item5">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="last month"
                    name="month"
                    value="Last Month"
                    checked={value.month === "Last Month"}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <label htmlFor="last month">Last Month</label>
                </div>
              </div>
              <div className="item6">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="month to date"
                    name="month"
                    value="Month to Date"
                    checked={value.month === "Month to Date"}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <label htmlFor="month to date">Month to Date</label>
                </div>
              </div>
              <div className="item7">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="week to date"
                    name="month"
                    value="Week to Date"
                    checked={value.month === "Week to Date"}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <label htmlFor="week to date">Week to Date</label>
                </div>
              </div>
              <div className="item8">
                <div className="toggle-radio">
                  <input
                    type="radio"
                    id="custom"
                    name="month"
                    value="Custom"
                    checked={value.month === "Custom"}
                    onChange={onChange}
                    disabled={disabled}
                  />
                  <label htmlFor="custom">Custom</label>
                </div>
              </div>
              {value.month === "Custom" && (
                <>
                  <div className="item9">
                    <FormInputs
                      type="month"
                      name="start_month"
                      value={value.start_month}
                      onChange={onChange}
                      disabled={disabled}
                    />
                  </div>
                  <div className="item10">To</div>
                  <div className="item11">
                    <FormInputs
                      type="month"
                      name="end_month"
                      value={value.end_month}
                      onChange={onChange}
                      disabled={disabled}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div>
        <TableComponent headers={headers} data={data}>
          <div>
            <label>Filter 1</label>
            <input type="text" />
          </div>
          <div>
            <label>Filter 2</label>
            <input type="text" />
          </div>
          <div>
            <p>
              add anything here to add to the advance filter stat instant update
              nad should be reliable i think try and error needed
            </p>
          </div>
        </TableComponent>
      </div>
    </div>
  );
}

export default AttendanceReport;
